import React, { useEffect, useState } from 'react'
import * as api from '../../../app/axios/api'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'
import AuthorizedComponent from '../../../components/AuthorizedComponent'
import { getCookie } from '../../../app/axios/CookieConfig'

const EmployeeDetails = () => {
  const { id } = useParams()
  // const userName = getCookie('name')

  const [employee, setEmployee] = useState(null)
  const [leaveDetails, setLeaveDetails] = useState([])
  const [expenseDetails, setExpenseDetails] = useState([])
  const [loading, setLoading] = useState(true)
  const [leaveLoading, setLeaveLoading] = useState(true)
  const [expenseLoading, setExpenseLoading] = useState(true)
  const [error, setError] = useState(null)
  const [activeTab, setActiveTab] = useState('leave') // Default active tab
  const [feeDetails, setFeeDetails] = useState([])
  const [admissionDetails, setAdmissionDetails] = useState([])

  // Delete confirmation modal state
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    itemId: null,
    itemType: '', // 'leave' or 'expense'
    itemInfo: '',
  })

  const tabs = [
    { id: 'leave', label: 'Leave' },
    { id: 'expense', label: 'Expense' },
    { id: 'fee', label: 'Fee' },
    { id: 'admission', label: 'Admission' },
  ]
  const fetchEmployeeDetails = async (employeeId) => {
    if (!employeeId) return
    try {
      setLoading(true)
      const res = await api.fetchOneEmployee(employeeId)
      if (res?.data) {
        setEmployee(res.data)
        setError(null)
      }
    } catch (error) {
      console.error('Error fetching employee details:', error)
      setError('Failed to load employee details')
      toast.error('Error fetching employee details')
    } finally {
      setLoading(false)
    }
  }
  const fetchLeaveDetails = async (employeeId) => {
    if (!employeeId) return
    try {
      setLeaveLoading(true)
      const res = await api.fetchOneLeaveById(employeeId)
      if (res?.data) {
        const leaveData = Array.isArray(res.data) ? res.data : [res.data]
        setLeaveDetails(leaveData)
      } else {
        setLeaveDetails([])
      }
    } catch (error) {
      console.error('Error fetching leave details:', error)
      if (error?.response?.status !== 404) {
        toast.error('Error fetching leave details')
      }
      setLeaveDetails([])
    } finally {
      setLeaveLoading(false)
    }
  }
  const fetchFee = async (employeeId) => {
    if (!employeeId) return
    try {
      setLeaveLoading(true)
      const res = await api.fetchFeeById(employeeId)
      console.log('fee', res)
      setFeeDetails(res.data || [])
    } catch (error) {
      console.error('Error fetching leave details:', error)
      if (error?.response?.status !== 404) {
        toast.error('Error fetching leave details')
      }
      setLeaveDetails([])
    } finally {
      setLeaveLoading(false)
    }
  }
  const fetchAdmission = async (employeeId) => {
    if (!employeeId) return
    try {
      setLeaveLoading(true)
      const res = await api.fetchAdmissionByUserId(employeeId)
      console.log('fee', res)
      setAdmissionDetails(res.data || [])
    } catch (error) {
      console.error('Error fetching leave details:', error)
      if (error?.response?.status !== 404) {
        toast.error('Error fetching leave details')
      }
      setLeaveDetails([])
    } finally {
      setLeaveLoading(false)
    }
  }

  const fetchExpenseDetails = async (employeeId) => {
    if (!employeeId) return
    try {
      setExpenseLoading(true)
      // API call - apna API function use karo
      const res = await api.fetchExpanseById(employeeId)
      // Dummy data for now

      setExpenseDetails(res.data || [])
    } catch (error) {
      console.error('Error fetching expense details:', error)
      toast.error('Error fetching expense details')
      setExpenseDetails([])
    } finally {
      setExpenseLoading(false)
    }
  }
  console.log(feeDetails)

  // Delete modal open
  const openDeleteModal = (itemId, itemType, itemInfo) => {
    setDeleteModal({ isOpen: true, itemId, itemType, itemInfo })
  }

  const closeDeleteModal = () => {
    setDeleteModal({ isOpen: false, itemId: null, itemType: '', itemInfo: '' })
  }

  const confirmDelete = async () => {
    if (!deleteModal.itemId) return
    try {
      if (deleteModal.itemType === 'leave') {
        await api.deleteLeave(deleteModal.itemId)
        toast.success('Leave deleted successfully')
        if (employee?.id) fetchLeaveDetails(employee.id)
      } else if (deleteModal.itemType === 'expense') {
        // await api.deleteExpense(deleteModal.itemId)
        toast.success('Expense deleted successfully')
        if (employee?.id) fetchExpenseDetails(employee.id)
      }
      closeDeleteModal()
    } catch (error) {
      console.error('Error deleting:', error)
      toast.error(`Error deleting ${deleteModal.itemType}`)
    }
  }

  const updateEmployeeLeave = async (leaveId) => {
    if (!leaveId) return
    try {
      await api.updateLeave(leaveId, { is_approval: true })
      toast.success('Leave approved successfully')
      if (employee?.id) fetchLeaveDetails(employee.id)
    } catch (error) {
      console.error('Error updating leave:', error)
      if (error?.message) {
        toast.error(error.response?.data?.message)
      }
    }
  }

  const updateExpenseApproval = async (expenseId) => {
    if (!expenseId) return
    try {
      await api.updateExpanse(expenseId, { is_approval: true })
      toast.success('Expense approved successfully')
      if (employee?.id) fetchExpenseDetails(employee.id)
    } catch (error) {
      console.error('Error updating expense:', error)
      if (error?.message) {
        toast.error(error?.response?.data?.message)
      }
    }
  }

  useEffect(() => {
    if (id) {
      fetchEmployeeDetails(id)
      fetchLeaveDetails(id)
      fetchExpenseDetails(id)
      fetchFee(id)
      fetchAdmission(id)
    }
  }, [id])

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A'
    try {
      const date = new Date(dateString)
      if (isNaN(date.getTime())) return 'Invalid Date'
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
    } catch (error) {
      return 'Invalid Date'
    }
  }

  // Leave Tab Content
  const LeaveTabContent = () => (
    <div>
      {leaveLoading ? (
        <p className='text-gray-500'>Loading leave details...</p>
      ) : leaveDetails.length > 0 ? (
        <div className='space-y-4'>
          {leaveDetails.map((leave, index) => (
            <div
              key={leave.id || index}
              className='border rounded-lg p-4 bg-gray-50'
            >
              <div className='flex items-center justify-between pb-3 border-b'>
                <div>
                  <p className='text-sm text-gray-600'>Leave Period</p>
                  <p className='font-semibold'>
                    {formatDate(leave.leave_start_date)} -{' '}
                    {formatDate(leave.leave_end_date)}
                  </p>
                </div>
                <div className='text-right'>
                  <p className='text-sm text-gray-600'>Total Days</p>
                  <p className='font-semibold text-lg'>
                    {leave.total_number_of_leave_days_requested || 0} days
                  </p>
                </div>
              </div>
              <div className='mt-3 grid grid-cols-1 md:grid-cols-2 gap-3'>
                <div>
                  <p className='text-sm text-gray-600'>Reason</p>
                  <p className='font-medium'>
                    {leave.reason_for_leave || 'N/A'}
                  </p>
                </div>
                <div>
                  <p className='text-sm text-gray-600'>Submission Date</p>
                  <p className='font-medium'>
                    {formatDate(leave.date_of_submission)}
                  </p>
                </div>
              </div>
              {leave.half_leave?.valid && (
                <div className='mt-2'>
                  <p className='text-sm text-gray-600'>Half Leave</p>
                  <p className='font-medium'>{leave.half_leave.h_leave}</p>
                </div>
              )}
              <div className='pt-3 mt-3 border-t'>
                <div className='flex items-center gap-3 flex-wrap'>
                  <span
                    className={`px-4 py-2 rounded-full font-semibold ${
                      leave.is_approval
                        ? 'bg-green-100 text-green-800'
                        : 'bg-yellow-100 text-yellow-800'
                    }`}
                  >
                    {leave.is_approval ? '✓ Approved' : '⏳ Pending'}
                  </span>
                  {leave.is_approval && leave.approval_by && (
                    <span className='text-sm text-gray-600'>
                      by <strong>{leave.approval_by}</strong>
                    </span>
                  )}
                  <AuthorizedComponent allowedRoles={['admin', 'manager']}>
                    {!leave.is_approval && (
                      <button
                        onClick={() => updateEmployeeLeave(leave.id)}
                        className='px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700'
                        disabled={!leave.id}
                      >
                        Approve
                      </button>
                    )}
                    <button
                      onClick={() =>
                        openDeleteModal(
                          leave.id,
                          'leave',
                          `${formatDate(leave.leave_start_date)} - ${formatDate(
                            leave.leave_end_date,
                          )}`,
                        )
                      }
                      className='px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700'
                      disabled={!leave.id}
                    >
                      Delete
                    </button>
                  </AuthorizedComponent>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className='text-gray-500'>No leave details found</p>
      )}
    </div>
  )

  // Expense Tab Content
  const ExpenseTabContent = () => (
    <div>
      {expenseLoading ? (
        <p className='text-gray-500'>Loading expense details...</p>
      ) : expenseDetails.length > 0 ? (
        <div className='space-y-4'>
          {expenseDetails.map((expense, index) => (
            <div
              key={expense.id || index}
              className='border rounded-lg p-4 bg-gray-50'
            >
              <div className='flex items-center justify-between pb-3 border-b'>
                <div>
                  <p className='text-sm text-gray-600'>Product/Service</p>
                  <p className='font-semibold text-lg'>
                    {expense.for_product || 'N/A'}
                  </p>
                </div>
                <div className='text-right'>
                  <p className='text-sm text-gray-600'>Amount</p>
                  <p className='font-bold text-xl text-blue-600'>
                    ₹{expense.amount || 0}
                  </p>
                </div>
              </div>
              <div className='mt-3 grid grid-cols-2 md:grid-cols-4 gap-3'>
                <div>
                  <p className='text-sm text-gray-600'>Category</p>
                  <p className='font-medium'>{expense.category || 'N/A'}</p>
                </div>
                <div>
                  <p className='text-sm text-gray-600'>Expense Date</p>
                  <p className='font-medium'>
                    {formatDate(expense.expense_date)}
                  </p>
                </div>
                <div>
                  <p className='text-sm text-gray-600'>Purchase From</p>
                  <p className='font-medium'>
                    {expense.purchase_from || 'N/A'}
                  </p>
                </div>
                <div>
                  <p className='text-sm text-gray-600'>Payment Mode</p>
                  <p className='font-medium capitalize'>
                    {expense.payment_mode || 'N/A'}
                  </p>
                </div>
              </div>
              {expense.note && (
                <div className='mt-2'>
                  <p className='text-sm text-gray-600'>Note</p>
                  <p className='font-medium'>{expense.note}</p>
                </div>
              )}
              <div className='mt-2'>
                <p className='text-sm text-gray-600'>Spent By</p>
                <p className='font-medium'>{expense.user_name || 'N/A'}</p>
              </div>
              <div className='pt-3 mt-3 border-t'>
                <div className='flex items-center gap-3 flex-wrap'>
                  <span
                    className={`px-4 py-2 rounded-full font-semibold ${
                      expense.is_approval
                        ? 'bg-green-100 text-green-800'
                        : 'bg-yellow-100 text-yellow-800'
                    }`}
                  >
                    {expense.is_approval ? '✓ Approved' : '⏳ Pending'}
                  </span>
                  {expense.is_approval && expense.approved_by_name && (
                    <span className='text-sm text-gray-600'>
                      by <strong>{expense.approved_by_name}</strong>
                    </span>
                  )}
                  {expense.admin_approved && (
                    <span className='px-3 py-1 rounded-full text-sm bg-purple-100 text-purple-800'>
                      Admin Approved
                    </span>
                  )}
                  <AuthorizedComponent allowedRoles={['admin', 'manager']}>
                    {!expense.is_approval && (
                      <button
                        onClick={() => updateExpenseApproval(expense.id)}
                        className='px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700'
                        disabled={!expense.id}
                      >
                        Approve
                      </button>
                    )}
                    <button
                      onClick={() =>
                        openDeleteModal(
                          expense.id,
                          'expense',
                          `₹${expense.amount} - ${expense.for_product}`,
                        )
                      }
                      className='px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700'
                      disabled={!expense.id}
                    >
                      Delete
                    </button>
                  </AuthorizedComponent>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className='text-gray-500'>No expense details found</p>
      )}
    </div>
  )

  // Admission Tab Content (Placeholder)
  const AdmissionTabContent = () => (
    <div className='space-y-3'>
      {' '}
      {/* Cards ke beech thoda gap */}
      {leaveLoading ? (
        <p className='text-gray-500 text-sm'>Loading admission details...</p>
      ) : admissionDetails.length > 0 ? (
        admissionDetails.map((admission, index) => (
          <div
            key={admission.id || index}
            className='flex flex-wrap md:flex-nowrap items-center justify-between border border-gray-200 rounded-lg p-3 bg-white hover:bg-gray-50 transition-colors shadow-sm'
          >
            {/* Left Side: Name and Course */}
            <div className='flex items-center gap-4 w-full md:w-1/3'>
              <div className='h-10 w-10 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-sm shrink-0'>
                {admission.name.charAt(0)}
              </div>
              <div className='truncate'>
                <h3 className='font-bold text-gray-800 text-sm leading-tight'>
                  {admission.name}
                </h3>
                <p className='text-xs text-blue-600 font-medium'>
                  {admission.course}
                </p>
              </div>
            </div>

            {/* Middle: Enrollment and Date */}
            <div className='flex flex-col w-1/2 md:w-1/4 mt-2 md:mt-0'>
              <p className='text-[10px] text-gray-400 uppercase tracking-wider font-semibold'>
                Enrollment / Date
              </p>
              <p className='text-xs text-gray-700 truncate'>
                {admission.enrollment_number.trim() || 'N/A'} •{' '}
                {formatDate(admission.created_at)}
              </p>
            </div>

            {/* Fee Section: Compact Row */}
            <div className='flex flex-col w-1/2 md:w-1/4 mt-2 md:mt-0 md:text-right'>
              <p className='text-[10px] text-gray-400 uppercase tracking-wider font-semibold'>
                Net Fee
              </p>
              <p className='text-sm font-bold text-gray-900'>
                ₹{admission.fee - admission.discount}
                <span className='text-[10px] text-gray-400 font-normal line-through ml-1 italic'>
                  ₹{admission.fee}
                </span>
              </p>
            </div>

            {/* Right Side: Status Badge */}
            <div className='w-full md:w-auto mt-3 md:mt-0 flex items-center justify-between md:justify-end gap-3'>
              <span
                className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${
                  admission.status === 'running'
                    ? 'bg-green-100 text-green-700'
                    : 'bg-gray-100 text-gray-700'
                }`}
              >
                {admission.status}
              </span>
            </div>
          </div>
        ))
      ) : (
        <p className='text-gray-500 text-sm py-4 text-center border-2 border-dashed rounded-lg'>
          No admissions found.
        </p>
      )}
    </div>
  )

  // Fee Tab Content (Mapped with your data)
  const FeeTabContent = () => (
    <div className='space-y-3'>
      {leaveLoading ? ( // Reuse leaveLoading or use a separate feeLoading if you have one
        <p className='text-gray-500 text-sm'>Loading fee details...</p>
      ) : feeDetails.length > 0 ? (
        feeDetails.map((fee, index) => (
          <div
            key={fee.id || index}
            className='flex flex-wrap md:flex-nowrap items-center justify-between border border-gray-200 rounded-lg p-4 bg-white hover:bg-gray-50 transition-colors shadow-sm'
          >
            {/* Left Side: Student Name & Receipt ID */}
            <div className='flex items-center gap-4 w-full md:w-1/4'>
              <div className='h-10 w-10 rounded-full bg-green-100 text-green-600 flex items-center justify-center font-bold text-sm shrink-0'>
                {fee.name ? fee.name.charAt(0) : 'S'}
              </div>
              <div className='truncate'>
                <h3 className='font-bold text-gray-800 text-sm leading-tight'>
                  {fee.name || 'N/A'}
                </h3>
                <p className='text-[10px] text-gray-500 font-medium uppercase'>
                  Receipt: #{fee.receipt_id}
                </p>
              </div>
            </div>

            {/* Middle: Payment Mode & Date */}
            <div className='flex flex-col w-1/2 md:w-1/4 mt-2 md:mt-0'>
              <p className='text-[10px] text-gray-400 uppercase tracking-wider font-semibold'>
                Payment Mode / Date
              </p>
              <p className='text-xs text-gray-700'>
                <span
                  className={`px-1.5 py-0.5 rounded-md mr-2 ${fee.payment_mode === 'Cash' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'}`}
                >
                  {fee.payment_mode}
                </span>
                {formatDate(fee.fee_submit_date)}
              </p>
            </div>

            {/* Money Section: Paid Amount & Due */}
            <div className='flex flex-col w-1/2 md:w-1/4 mt-2 md:mt-0 md:text-right'>
              <p className='text-[10px] text-gray-400 uppercase tracking-wider font-semibold'>
                Amount Paid
              </p>
              <p className='text-base font-bold text-green-600'>
                ₹{fee.amount}
              </p>
              <p className='text-[10px] text-red-500'>Due: ₹{fee.due_fee}</p>
            </div>

            {/* Right Side: Total Fee & Discount */}
            <div className='w-full md:w-auto mt-3 md:mt-0 flex items-center justify-between md:justify-end gap-6 border-t md:border-t-0 pt-2 md:pt-0'>
              <div className='text-right'>
                <p className='text-[10px] text-gray-400 uppercase font-semibold'>
                  Course Fee
                </p>
                <p className='text-xs font-medium text-gray-600 mt-1'>
                  ₹{fee.total_fee}
                  {fee.discount > 0 && (
                    <span className='ml-1 text-[10px] text-green-500 bg-green-50 px-1 rounded'>
                      -{fee.discount} Off
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p className='text-gray-500 text-sm py-8 text-center border-2 border-dashed rounded-lg'>
          No fee records found.
        </p>
      )}
    </div>
  )

  const renderTabContent = () => {
    switch (activeTab) {
      case 'leave':
        return <LeaveTabContent />
      case 'expense':
        return <ExpenseTabContent />
      case 'fee':
        return <FeeTabContent />
      case 'admission':
        return <AdmissionTabContent />
      default:
        return <LeaveTabContent />
    }
  }

  if (error) {
    return (
      <div className='p-6 bg-red-50 rounded-lg'>
        <p className='text-red-600'>{error}</p>
      </div>
    )
  }

  return (
    <div className='space-y-6'>
      {/* Delete Confirmation Modal */}
      {deleteModal.isOpen && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
          <div className='bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl'>
            <div className='text-center'>
              <div className='mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4'>
                <svg
                  className='h-6 w-6 text-red-600'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z'
                  />
                </svg>
              </div>
              <h3 className='text-lg font-semibold text-gray-900 mb-2'>
                Delete {deleteModal.itemType === 'leave' ? 'Leave' : 'Expense'}
              </h3>
              <p className='text-sm text-gray-500 mb-1'>
                Are you sure you want to delete?
              </p>
              <p className='text-sm font-medium text-gray-700 mb-4'>
                {deleteModal.itemInfo}
              </p>
              <p className='text-xs text-red-500 mb-4'>
                This action cannot be undone.
              </p>
            </div>
            <div className='flex gap-3 justify-center'>
              <button
                onClick={closeDeleteModal}
                className='px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300'
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className='px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700'
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Employee Details Card */}
      <div className='p-6 bg-white rounded-lg shadow-md'>
        {loading ? (
          <p>Loading employee details...</p>
        ) : employee ? (
          <div>
            <h2 className='text-2xl font-bold mb-4'>Employee Details</h2>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
              <div>
                <p className='text-sm text-gray-600'>Name</p>
                <p className='font-semibold'>{employee.name || 'N/A'}</p>
              </div>
              <div>
                <p className='text-sm text-gray-600'> Email</p>
                <p className='font-semibold'>{employee.email || 'N/A'}</p>
              </div>
              <div>
                <p className='text-sm text-gray-600'>Department</p>
                <p className='font-semibold'>{employee.department || 'N/A'}</p>
              </div>
              <div>
                <p className='text-sm text-gray-600'>Position</p>
                <p className='font-semibold'>{employee.role || 'N/A'}</p>
              </div>
            </div>
          </div>
        ) : (
          <p className='text-gray-500'>No employee details found</p>
        )}
      </div>

      {/* Tabs Section */}
      <div className='bg-white rounded-lg shadow-md overflow-hidden'>
        {/* Tab Headers */}
        <div className='border-b'>
          <div className='flex'>
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-4 text-sm font-medium transition-colors duration-200 border-b-2 ${
                  activeTab === tab.id
                    ? 'border-blue-600 text-blue-600 bg-blue-50'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className='p-6'>{renderTabContent()}</div>
      </div>
    </div>
  )
}

export default EmployeeDetails
